<mt-btn (onAction)="startCalling()" class="icon outline mx-8" [disabled]="disabledBtn">
  <span [matTooltip]="'Call'" class="ic_mobile"></span>
</mt-btn>
